export class EditMatchedLeadsProductHiringArea {
    lat: number;
    lng: number;
    radius: number;
}